/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Change Password page component. The component displays the Change Password page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 09/01/2020 
 */
/*
 * CP_PC_01
 * */
import React, { Component } from 'react';
import * as ChangePasswordAction from '../actions/ChangePasswordAction';
import ChangePasswordStore from '../stores/ChangePasswordStore';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next'
import * as CookieService from '../CookieService';
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import * as $ from 'jquery';
import swal from 'sweetalert';
const passwrdRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\s]).{10,}$");
class ChangePassword extends Component {
    /**
     * CP_PC_03
     * Declare a “constructor” method with “props” as its parameters.
     */
    constructor(props) {
        super(props);
        /**
     * CP_PC_04
     * */
        this.RespMessage = this.RespMessage.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);
        this.state = {
            CHangePassword: true,
            LoginUserId: "",
            OldPwId: "",
            NewPwId: "",
            CNewPwId: "",
            OldPass: "",
            NewPass: "",
            CNewPass: "",
            errorMsg1: '',
            errorMsg2: '',
            errorMsg3: '',
            errorMsg: ''
        }
    }
    /**
     * CP_PC_05
     * */
    componentDidMount() {
        //const queryParams = new URLSearchParams(window.location.search)
        //const QS_src = queryParams.get('USERID');
        //this.setState({ LoginUserId: QS_src })
        //console.log("queryParams", queryParams)
        //console.log("QS_src", QS_src)
        /**
     * CP_PC_06
     * */
        let displayText = CookieService.getLocalStorageValues("displayText");
        let isredirect = CookieService.getLocalStorageValues("isredirect");
        let resultMessage = CookieService.getLocalStorageValues("resultMessage");

        this.props.DisplayOutageData(isredirect, displayText, resultMessage);
        ChangePasswordStore.on("ChangePwd", this.RespMessage);
        $(".login-control").on('keyup change', (event) => {
            let id = $(event.target).attr('id');
            let targetval = $(event.target).val();
                    $(".login-control").off('keyup change');
            // Call the validation function
            this.validateInput(id, targetval);
        });
    }
    componentWillUnmount() {
        ChangePasswordStore.removeListener("ChangePwd", this.RespMessage.bind(this));
        $(".login-control").off('keyup change');
    }
    //WW-887 Restrict the paste action in password fields
    handlePaste = (e) => {
        e.preventDefault();
    };
    /**
     * CP_PC_08 && CP_PC_12
     * */
    UpdatePassword = () => {
        let OldPassword = $('#OldPwId').val();
        let NewPassword = $('#NewPwId').val();
        let ConfirmPassword = $('#CNewPwId').val();
        console.log(ConfirmPassword);

        let validate = 0;
        let ErrorMsg1 = ''; 
        let ErrorMsg2 = ''; 
        let ErrorMsg3 = '';

        // Validate Old Password
        if (!OldPassword) {
            ErrorMsg1 = "Old Password is required";
            validate = 1;
        }

        // Validate New Password
        if (!NewPassword) {
            ErrorMsg2 = "New Password is required";
            validate = 1;
        } else {
            if (passwrdRegex.test(NewPassword) === false) {
                validate = 1;
                ErrorMsg2 = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.";
            } else if (NewPassword.length > 128) {
                validate = 1;
                ErrorMsg2 = "Password must be within 128 characters!";
            } else if (NewPassword !== ConfirmPassword) {
                ErrorMsg3 = "Password doesn't match";
                validate = 1;
            }
        }

        // Validate Confirm Password
        if (!ConfirmPassword) {
            ErrorMsg3 = "Confirm Password is required";
            validate = 1;
        } else {
            if (passwrdRegex.test(ConfirmPassword) === false) {
                validate = 1;
                ErrorMsg3 = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.";
            } else if (ConfirmPassword.length > 128) {
                validate = 1;
                ErrorMsg3 = "Password must be within 128 characters!";
            } else if (ConfirmPassword !== NewPassword) {
                ErrorMsg3 = "Password doesn't match";
                validate = 1;
            }

        }
        
        if (validate === 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const QS_src = queryParams.get('USERID');
            this.setState({ LoginUserId: QS_src });

            console.log("queryParams", queryParams);
            console.log("QS_src", QS_src);

            let ChangePassBo = {
                Session_UserID: QS_src,
                Old_Pwd: OldPassword,
                New_Pwd: NewPassword
            };

            ChangePasswordAction.UpdateBtn_clk(ChangePassBo);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        
        this.setState({
            errorMsg1: ErrorMsg1,
            errorMsg2: ErrorMsg2,
            errorMsg3: ErrorMsg3
        });
    }
    /**
     * CP_PC_09 && CP_PC_10 && CP_PC_11
     * */
    RespMessage = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Validate = JSON.parse(ChangePasswordStore.ChangePwdList);
        console.log("Validate", Validate)
        let MesageTable = Validate.MessageTable
        if (MesageTable[0].OldPassword_Not_Exist != null) {
            this.setState({ errorMsg: MesageTable[0].OldPassword_Not_Exist})
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: MesageTable[0].Success_Message
            });
            //alert(MesageTable[0].Success_Message)
            CookieService.updateLocalStorageValues("ShowNormalLogin", true);
            CookieService.updateLocalStorageValues("BackFromForgotOrChgPass", true);
            this.props.history.push({
                pathname: '/'
            });
        }
    }
    CancelClick = () => {
        CookieService.updateLocalStorageValues("ShowNormalLogin", true);
        CookieService.updateLocalStorageValues("BackFromForgotOrChgPass", true);
        this.props.history.push({
            pathname: '/'
        });
    }
    /* WW-887 **/
    handleClickShowPassword = (values, label) => {
        if (label == "OLDPASS") {
            this.setState({ oldPw: !this.state.oldPw })
        }
        else if (label == "NEWPASS") {
            this.setState({ newPw: !this.state.newPw })
        }
        else {
            this.setState({ conPw: !this.state.conPw })
        }
    };
    handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    handleProfileFormChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });

        let id = event.target.id;
        let targetval = event.target.value;
        let ErrorMsg1 = this.state.errorMsg1; 
        let ErrorMsg2 = this.state.errorMsg2; 
        let ErrorMsg3 = this.state.errorMsg3; 

        switch (id) {
            case "OldPwId": {
                if (targetval == "") {
                    ErrorMsg1 = "Old Password is required";
                } else {
                    ErrorMsg1 = ""
                }
                break;
            }
            case "NewPwId": {
                let Password2 = $('#CNewPwId').val()

                if (targetval == "") {
                    ErrorMsg2 = "New Password is required";
                } else if (Password2 && Password2 != targetval) {
                    ErrorMsg3 = "Password doesn't match";
                } else if (passwrdRegex.test(targetval) == false) {
                    ErrorMsg2 = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.";
                } else if (targetval.length > 128) {
                    ErrorMsg2 = "Password must be within 128 characters!";
                } else {
                    ErrorMsg2 = ""
                }
                break;
            }
            case "CNewPwId": {
                let Passwordl = $('#NewPwId').val()

                if (targetval == "") {
                    ErrorMsg3 = "Confirm Password is required";
                } else if (!Passwordl) {
                    ErrorMsg3 = "Please enter password";
                } else if (Passwordl != targetval) {
                    ErrorMsg3 = "Password doesn't match";
                } else if (passwrdRegex.test(targetval) == false) {
                    ErrorMsg3 = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters.";
                } else if (targetval.length > 128) {
                    ErrorMsg3 = "Password must be within 128 characters!";
                } else {
                    ErrorMsg3 = ""
                }
                break;
            }
            default:
                break;
        }

       
        this.setState({
            errorMsg1: ErrorMsg1,
            errorMsg2: ErrorMsg2,
            errorMsg3: ErrorMsg3
        });
    }
    validateInput = (id, targetval) => {
        let ErrorMsg1 = '';
        let ErrorMsg2 = '';
        let ErrorMsg3 = '';

        switch (id) {
            case "Oldpass": {
                if (targetval === "") {
                    ErrorMsg1 = "Old Password is required";
                }
                break;
            }
            case "NewPass": {
                if (targetval === "") {
                    ErrorMsg2 = "New Password is required";
                } else {
                    let firstletter1 = targetval.slice(0, 1);
                    let Numtest = targetval.match(/[0-9]/g);
                    if (targetval.length < 6) {
                        ErrorMsg2 = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!";
                    } else if ((/[a-zA-Z]/).test(firstletter1) === false || Numtest == null || Numtest === "") {
                        ErrorMsg2 = "Password must contain at least 1 number and 1 letter - must start with a letter!";
                    }
                }
                break;
            }
            case "ConNewPass": {
                if (targetval === "") {
                    ErrorMsg3 = "Confirm Password is required";
                } else {
                    let firstletter = targetval.slice(0, 1);
                    let NumtestC = targetval.match(/[0-9]/g);
                    if (targetval.length < 6) {
                        ErrorMsg3 = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!";
                    } else if ((/[a-zA-Z]/).test(firstletter) === false || NumtestC == null || NumtestC === "") {
                        ErrorMsg3 = "Password must contain at least 1 number and 1 letter - must start with a letter!";
                    }
                }
                break;
            }
            default:
                break;
        }

        // Set state with the error messages
        this.setState({
            errorMsg1: ErrorMsg1,
            errorMsg2: ErrorMsg2,
            errorMsg3: ErrorMsg3
        });
    }

    render() {
        const { t } = this.props;
        return (this.state.CHangePassword === true ? (
            <React.Fragment>
                <p className="text-white mt-4 mb-3 font-24 font-thin"><Trans>change_pwd</Trans></p>
                <div className="Password position-relative">
                    <Input
                        type={this.state.oldPw ? "text" : "password"}
                        style={{ color: "white" }}
                        id="OldPwId"
                        onPaste={this.handlePaste}
                        className="form-control font-12 login-control pb-1 pr-0"
                        placeholder={t("Enter Old Password")}
                        name="OldPwId"
                        inputProps={{ maxLength: 128 }}
                        value={this.state.OldPwId}
                        onChange={this.handleProfileFormChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    style={{ color: "#707070" }}
                                    onClick={(e) => this.handleClickShowPassword(e, "OLDPASS")}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.oldPw ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <div className="mc-Margin pb-3">
                        <span className="errorcolour DropDown-Font-Size float-left text-left"><Trans>{this.state.errorMsg1}</Trans></span>
                    </div>
                </div>
                <div className="Password position-relative">
                    <Input
                        type={this.state.newPw ? "text" : "password"}
                        id="NewPwId"
                        style={{ color: "white" }}
                        onPaste={this.handlePaste}
                        className="form-control font-12 login-control pb-1 pr-0"
                        placeholder={t("Enter New Password")}
                        name="NewPwId"
                        inputProps={{ maxLength: 128 }}
                        value={this.state.NewPwId}
                        onChange={this.handleProfileFormChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    style={{ color: "#707070" }}
                                    onClick={(e) => this.handleClickShowPassword(e, "NEWPASS")}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.newPw ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <div className="mc-Margin pb-3">
                        <div className="errorcolour DropDown-Font-Size float-left text-left"><Trans>{this.state.errorMsg2}</Trans></div>
                    </div>
                </div>
                <div className="Password position-relative">
                    <Input
                        type={this.state.conPw ? "text" : "password"}
                        id="CNewPwId"
                        style={{ color: "white" }}
                        onPaste={this.handlePaste}
                        className="form-control font-12 login-control pb-1 pr-0"
                        placeholder={t("Enter Confirm Password")}
                        name="CNewPwId"
                        inputProps={{ maxLength: 128 }}
                        value={this.state.CNewPwId}
                        onChange={this.handleProfileFormChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    style={{ color: "#707070" }}
                                    onClick={(e) => this.handleClickShowPassword(e, "CONPASS")}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.conPw ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <div className="mc-Margin pb-3">
                        <div className="errorcolour DropDown-Font-Size float-left text-left"><Trans>{this.state.errorMsg3}</Trans></div>
                    </div>
                </div>
                    <div className="mb-3 pb-2">
                        <div className="errorcolour DropDown-Font-Size float-left text-left"><Trans>{this.state.errorMsg}</Trans></div>
                    </div>
                <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        <button className="btn reg-cancel-btn w-100" onClick={() => this.CancelClick()}><Trans>Cancel</Trans></button>
                    </div>
                    <div className="col-md-6">
                        <button className="btn btn-primary custom-btn-primary primary-btn w-100 wallet-btn" onClick={() => this.UpdatePassword()}><Trans>Update</Trans></button>
                    </div>
                </div>
            </React.Fragment>
        ) : null);
    }
}
export default withTranslation()(ChangePassword);


